'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _ProfileFirstName = require('../Profile/ProfileFirstName');

var _ProfileFirstName2 = _interopRequireDefault(_ProfileFirstName);

var _UserIcon = require('../Icon/UserIcon');

var _UserIcon2 = _interopRequireDefault(_UserIcon);

var _Badge = require('../Core/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rules = function rules() {
  return {
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    avatar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      color: 'currentColor',
      fontSize: '14px',
      textTransform: 'none',
      fontWeight: 'normal'
    },
    avatarContainer: {
      display: 'none',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginLeft: '14px',
      desktop: {
        display: 'flex'
      }
    },
    avatarDescription: {
      fontSize: '12px',
      textDecoration: 'underline'
    },
    avatarWrapperPicture: {
      display: 'inline-block',
      borderRadius: '50%',
      width: '22px',
      height: '22px',
      backgroundColor: '#d8d8d8',
      overflow: 'hidden',
      desktop: {
        width: '32px',
        height: '32px'
      }
    },
    avatarPicture: {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  };
};

var HeaderProfileAvatar = function HeaderProfileAvatar(props) {
  var loggedIn = props.loggedIn,
      profile = props.profile,
      styles = props.styles,
      mobile = props.mobile,
      notification = props.notification;


  return (0, _preact.h)(
    'div',
    { className: styles.wrapper },
    loggedIn ? (0, _preact.h)(
      'span',
      { className: styles.avatar },
      (0, _preact.h)(
        'span',
        { className: styles.avatarWrapperPicture },
        profile.picture && (0, _preact.h)('img', { src: profile.picture, className: styles.avatarPicture })
      ),
      (0, _preact.h)(
        'span',
        { className: styles.avatarContainer },
        (0, _preact.h)(
          'span',
          null,
          (0, _preact.h)(_ProfileFirstName2.default, { name: profile.name })
        ),
        (0, _preact.h)(
          'span',
          { className: styles.avatarDescription },
          'Minha conta'
        )
      )
    ) : (0, _preact.h)(_UserIcon2.default, null),
    loggedIn && notification.active && mobile && notification.unread > 0 && (0, _preact.h)(_Badge2.default, null)
  );
};

exports.default = (0, _preactFela.connect)(rules)(HeaderProfileAvatar);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderProfileAvatar.js
// module id = 201
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38